import {observer} from 'mobx-react';
import React from 'react';
import {PromiseMessage} from '../../../../lib/components';
import {X7PushableBlockStore} from '../X7PushableBlockStore';

@observer
export class DeleteBlockControls extends React.Component<{ store: X7PushableBlockStore }> {
  render() {
    const {store} = this.props;

    if (store.deleteBlock === null)
      return null;

    const deleteBlock = store.deleteBlock;
    const isFailure = deleteBlock.save?.isRejected === true;

    return (<>
        <PromiseMessage label="Deleting block" state={deleteBlock.save} align="right"/>
        {
          isFailure &&
          <div className="row justify-content-end">
            <div className="col-auto">
              <button type="button"
                      className="btn btn-primary"
                      onClick={store.cancel}>
                Cancel
              </button>
            </div>
          </div>
        }
      </>
    );
  }
}
